export const Color = {
	borderActionDisabled: 'color-border-action-disabled',
	borderFeedbackErrorDefault: 'color-border-feedback-error-default',
	borderFeedbackInfoDefault: 'color-border-feedback-info-default',
	borderFeedbackSuccessDefault: 'color-border-feedback-success-default',
	borderFeedbackWarningDefault: 'color-border-feedback-warning-default',
	iconActionDefault: 'color-icon-action-default',
	iconActionSecondaryDefault: 'color-icon-action-secondary-default',
	iconActionSecondaryDisabled: 'color-icon-action-secondary-disabled',
	// NOTE: For some reason this doesn't work, maybe tailwind version?
	// iconActionDefault: 'text-(--design-color-icon-action-default)',
	iconFeedbackErrorDefault: 'color-icon-feedback-error-default',
	iconFeedbackErrorDefaultImportant: '!color-icon-feedback-error-default',
	iconFeedbackInfoDefault: 'color-icon-feedback-info-default',
	iconFeedbackSuccessDefault: 'color-icon-feedback-success-default',
	iconFeedbackSuccessDefaultImportant: '!color-icon-feedback-success-default',
	iconFeedbackWarningDefault: 'color-icon-feedback-warning-default',
	iconFeedbackWarningDefaultImportant: '!color-icon-feedback-warning-default',
	surfaceStatistic8: 'color-surface-statistic-8',
	textActionPrimaryDefault: 'color-text-action-primary-default',
	textNeutralDefault: 'color-text-neutral-default',
	textNeutralDefaultImportant: '!color-text-neutral-default',
	textNeutralDisabled: 'color-text-neutral-disabled',
	textNeutralInverted: 'color-text-neutral-inverted',
	textNeutralSubtle: 'color-text-neutral-subtle',
	textNeutralSubtleImportant: '!color-text-neutral-subtle',
	textActionSecondaryDisabled: 'color-text-action-secondary-disabled',
} as const;

export const BgColor = {
	surfaceActionChip10Default: 'bg-surface-action-chip-10-default',
	surfaceActionDefault: 'bg-surface-action-default',
	surfaceActionDisabled: 'bg-surface-action-disabled',
	surfaceActionMenuHover: 'bg-surface-action-menu-hover',
	surfaceActionPrimaryDefault: 'bg-surface-action-primary-default',
	surfaceActionSecondary: 'bg-surface-action-secondary',
	surfaceActionSecondaryActive: 'bg-surface-action-secondary-active',
	surfaceActionSecondaryHover: 'bg-surface-action-secondary-hover',
	surfaceActionSecondaryActiveImportant: '!bg-surface-action-secondary-active',
	surfaceFeedbackErrorDefault: 'bg-surface-feedback-error-default',
	surfaceFeedbackErrorDefaultImportant: '!bg-surface-feedback-error-default',
	surfaceFeedbackInfoDefault: 'bg-surface-feedback-info-default',
	surfaceFeedbackSuccessDefault: 'bg-surface-feedback-success-default',
	surfaceFeedbackSuccessDefaultImportant: '!bg-surface-feedback-success-default',
	surfaceFeedbackWarningDefault: 'bg-surface-feedback-warning-default',
	surfaceFeedbackWarningDefaultImportant: '!bg-surface-feedback-warning-default',
	surfaceNeutralDefault: 'bg-surface-neutral-default',
	surfaceNeutralPrimary: 'bg-surface-neutral-primary',
	surfaceNeutralSubtle: 'bg-surface-neutral-subtle',
	surfaceStatistic5: 'bg-surface-statistic-5',
} as const;
